import { render, staticRenderFns } from "./about-dzb.vue?vue&type=template&id=52b55b42&scoped=true&"
import script from "./about-dzb.vue?vue&type=script&lang=js&"
export * from "./about-dzb.vue?vue&type=script&lang=js&"
import style0 from "./about-dzb.vue?vue&type=style&index=0&id=52b55b42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b55b42",
  null
  
)

export default component.exports